import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {MerchantInfoService_GetMerchantInfoForProductSizeLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/merchant_info/v1/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';

export const useMerchantLegalInfo = ({
  productId,
  sizeId,
}: {
  productId: number;
  sizeId: number;
}) => {
  const fullSession = useFullSession();

  return useGrpcRequest(
    MerchantInfoService_GetMerchantInfoForProductSizeLazy,
    {
      session: fullSession!,
      productId,
      sizeId,
    },
    {
      disabled: !fullSession,
    },
  );
};
